import { Modal, Table, Typography } from 'antd';
import React from 'react';
import { BEHAVIOUR_ROWS } from '../../../common/constants';

const { Text, Title } = Typography;

const COLUMNS = [
  { title: 'Behaviour', dataIndex: 'label', key: 'label' },
  { title: 'Raw', dataIndex: 'rawCount', key: 'rawCount', align: 'center' },
  {
    title: 'Genuine',
    dataIndex: 'excusedCount',
    key: 'excusedCount',
    align: 'center',
  },
  {
    title: 'Effective',
    dataIndex: 'effectiveCount',
    key: 'effectiveCount',
    align: 'center',
  },
];

/**
 * ScoreBreakdownModal shows the per-behaviour deduction math behind an
 * employee's monthly attendance score, sourced from the attendanceScore query.
 */
function ScoreBreakdownModal({ open, loading, employeeName, data, onCancel }) {
  const breakdown = data?.breakdown || {};
  const rows = BEHAVIOUR_ROWS.map(({ key, label }) => ({
    key,
    label,
    ...(breakdown[key] || {}),
  }));

  return (
    <Modal
      title={
        employeeName ? `${employeeName} — Score Breakdown` : 'Score Breakdown'
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <div style={{ marginBottom: 16 }}>
        <Text type="secondary">Score</Text>
        <Title level={3} style={{ margin: 0 }}>
          {data?.score !== undefined && data?.score !== null
            ? data.score.toFixed(1)
            : 'N/A'}
        </Title>
      </div>
      <Table
        size="small"
        bordered
        pagination={false}
        loading={loading}
        columns={COLUMNS}
        dataSource={rows}
        rowKey="key"
      />
    </Modal>
  );
}

export default ScoreBreakdownModal;
